import { scaleBand } from 'd3-scale';
import noop from 'lodash/noop';
import { useRef } from 'react';

import { Wrapper } from 'shared/components/charts/components/Wrapper';
import { YAxis } from 'shared/components/charts/components/YAxis';
import { useGetYAxe } from 'shared/components/charts/hooks';
import { useResizeWidth } from 'shared/hooks/dom';

import { Chart } from './components/Chart';
import { WIDTH, HEIGHT, MARGIN, FONT_SIZE, WRAPPER } from './constants';
import { Provider } from './context';

import type { BarChartProps } from './types';
import type { FC } from 'react';

const xScaleMinStep = 64;

export const BarChart: FC<BarChartProps> = ({
  data,
  yAxis,
  TooltipContent,
  onInteract = noop,
  gradeType,
}) => {
  const chartElement = useRef(null);
  const { yScale, yLabels } = useGetYAxe(HEIGHT, yAxis);
  const wrapperWidth = useResizeWidth(chartElement, {
    defaultWidth: WIDTH,
    minWidth: data.length * xScaleMinStep,
  });
  const width = wrapperWidth - MARGIN.right - MARGIN.left;

  const xScale = scaleBand()
    .range([0, width])
    .domain(data.map(d => d.x))
    .padding(0.82)
    .round(true);

  return (
    <Wrapper>
      <Provider
        value={{
          data,
          wrapperWidth,
          width,
          yScale,
          yLabels,
          xScale,
          TooltipContent,
          onInteract,
          gradeType,
        }}
      >
        <YAxis
          margin={MARGIN}
          height={WRAPPER.height}
          fontSize={FONT_SIZE}
          yScale={yScale}
          yLabels={yLabels}
        />
        <Chart ref={chartElement} />
      </Provider>
    </Wrapper>
  );
};
